/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Category } from './category';
import { CategoryEvaluation } from './categoryEvaluation';
import { TaskResult } from './taskResult';

/**
 * Base class serializer for all OpenAPI serializers.  It only implements create/update method without any logic to prevent \"abstract\" warning by pylint.
 */
export interface CategoryGameResult { 
    category: Category;
    maxScore: string;
    score: string;
    percent: string;
    evaluation: CategoryEvaluation;
    taskResults: Array<TaskResult>;
}